import React, { useEffect, useId } from "react";
import Heading from "./Heading/Heading";
import img1 from "images/collections/Toofanimastismallp1.png";
import img2 from "images/collections/Toofanimastismallp2.png";
import img3 from "images/collections/Toofanimastismallp3.png";
import img4 from "images/collections/Toofanimastismallp4.png";
import img5 from "images/collections/explore15.png";
import CardCategory3, {
  CardCategory3Props,
} from "./CardCategories/CardCategory3";
import Glide from "@glidejs/glide";

export const CATS_DISCOVER: CardCategory3Props[] = [
  {
    name: "Corn Sandwich",
    textdesc: "text-[12px] sm:text-[14px] md:text-[16px] xl:text-[16px] 2xl:text-[16px] pr-[118px] sm:pr-[90px] md:pr-[105px] xl:pr-[115px] 2xl:pr-[80px] leading-5 md:leading-6	leading-relaxed",
    desc: "A delicious blend of sweet corn, creamy cheese, and savory spices.",
    featuredImage: img1,
    color: "bg-yellow-50",
    link: "/category",
  },
  {
    name: "Corn puff",
    textdesc: "text-[12px] md:text-[16px] xl:text-[16px] pr-[118px] 2xl:text-[16px] sm:pr-[90px] md:pr-[105px] xl:pr-[115px] 2xl:pr-[80px] leading-5 md:leading-6	leading-relaxed",
    desc: "Corn puffs are crispy, airy snacks made from cornmeal.",
    featuredImage: img2,
    color: "bg-red-50",
    link: "/category",
  },
  {
    name: "Rum Pum",
    textdesc: "text-[12px] md:text-[16px] xl:text-[16px] pr-[118px] 2xl:text-[16px] sm:pr-[90px] md:pr-[105px] xl:pr-[115px]  2xl:pr-[80px] leading-5 md:leading-6	leading-relaxed",
    desc: "A premium blend that delivers rich, smooth flavors with every sip.",
    featuredImage: img3,
    color: "bg-blue-50",
    link: "/category",
  },
  {
    name: "Corn puff",
    textdesc: "text-[12px] md:text-[16px] xl:text-[16px] pr-[118px] 2xl:text-[16px] sm:pr-[90px] md:pr-[105px]  xl:pr-[115px] 2xl:pr-[80px] leading-5 md:leading-6	leading-relaxed",
    desc: "Crunchy, airy, and lightly seasoned snacks made from cornmeal.",
    featuredImage: img4,
    color: "bg-green-50",
    link: "/category",
  },
  // {
  //   name: "Gift Hamper",
  //   textdesc: "text-xl md:text-2xl pr-[110px]",
  //   desc: "Give the gift <br /> of choice",
  //   featuredImage: img5,
  //   color: "bg-yellow-50",
  //   link: "/category/gift-hamper",
  // },
];

const DiscoverMoreSlider = () => {
  const id = useId();
  const UNIQUE_CLASS = "glidejs" + id.replace(/:/g, "_");

  useEffect(() => {
    // @ts-ignore
    const OPTIONS: Glide.Options = {
      perView: 2.8,
      gap: 32,
      bound: true,
      breakpoints: {
        1280: {
          gap: 28,
          perView: 2.5,
        },
        1279: {
          gap: 20,
          perView: 2.15,
        },
        1023: {
          gap: 20,
          perView: 1.6,
        },
        768: {
          gap: 20,
          perView: 1.2,
        },
        500: {
          gap: 20,
          perView: 1,
        },
      },
    };

    let slider = new Glide(`.${UNIQUE_CLASS}`, OPTIONS);
    slider.mount();
    return () => {
      slider.destroy();
    };
  }, [UNIQUE_CLASS]);

  return (
    <div className={`nc-DiscoverMoreSlider nc-p-l-container ${UNIQUE_CLASS} `}>
      <Heading
        className=" mb-8 lg:mb-8 text-custom-pink dark:text-custom-pink nc-p-r-container "
        desc=""
        // rightDescText="Good things are waiting for you"
        hasNextPrev
      >
        {/* &nbsp; */}
        {/* Discover more */}
      </Heading>
      <div className="" data-glide-el="track">
        <ul className="glide__slides">
          {CATS_DISCOVER.map((item, index) => (
            <li key={index} className={`glide__slide`}>
              <CardCategory3
                name={item.name}
                textdesc={item.textdesc}
                desc={item.desc}
                featuredImage={item.featuredImage}
                color={item.color}
                link={item.link}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DiscoverMoreSlider;
